module.exports = __webpack_public_path__ + "static/media/report-snack-icon.fee116bb.svg";